import {Badge} from 'react-bootstrap'

const STATUS = {
  CREADA: 'info',
  EXITOSA: 'success',
  ANULADA: 'dark',
  RECHAZADA: 'danger',
  EN_PROCESO: 'warning',
}

export const BadgeStatus = ({status}: {status: string}) => {
  return (
    <Badge bg={STATUS[status] || 'light'} className='text-white'>
      {status.replace('_', ' ')}
    </Badge>
  )
}
